


import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Table from "../../../../core/pagination/datatable";
import CommonFooter from "../../../../core/common/footer/commonFooter";
import Select from "react-select";
import { Payroll_API_BASE_URL } from "../PConfig/PConfig";
import { Spin } from "antd";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Filter, Search, RotateCcw } from "feather-icons-react/build/IconComponents";
import ImageWithBasePath from "../../../../core/img/imagewithbasebath";

const GroupPayrollReports = () => {
    const { id: reportiid } = useParams();
    const navigate = useNavigate();

    const [loading, setLoading] = useState(false);
    const [reportData, setReportData] = useState([]);
    const [columns, setColumns] = useState([]);

    // Filters
    const [selectedPayPeriod, setSelectedPayPeriod] = useState(null);
    const [selectedEmployee, setSelectedEmployee] = useState(null);
    const [selectedDepartment, setSelectedDepartment] = useState(null);
    const [selectedBranch, setSelectedBranch] = useState(null);

    // Master data
    const [branches, setBranches] = useState([]);
    const [departments, setDepartments] = useState([]);
    const [payPeriods, setPayPeriods] = useState([]);
    const [employees, setEmployees] = useState([]);

    const [token, setToken] = useState(null);
    const [superId, setSuperId] = useState(null);

    const [pdfLoading, setPdfLoading] = useState(false);
    const [excelLoading, setExcelLoading] = useState(false);
    const [showAdvancedSearch, setShowAdvancedSearch] = useState(false);

    useEffect(() => {
        // const sid = 10228;
        const t = sessionStorage.getItem("authToken");
        const sid = sessionStorage.getItem("PayrollSuperId");
        if (t && sid) {
            setToken(t);
            setSuperId(sid);
        } else {
            navigate("/signin");
        }
    }, [navigate]);

    useEffect(() => {
        if (!token || !superId) return;

        // Branches
        fetch(`${Payroll_API_BASE_URL}portal/branch/getbranch?superid=${superId}`, {
            headers: { Authorization: `Bearer FFC10000-022A-4030-0000-DA26AE3BA419-3` },
        })
            .then(r => r.json())
            .then(data => data?.status && setBranches(data.ResultData || []))
            .catch(console.error);

        // Departments
        fetch(`${Payroll_API_BASE_URL}portal/department/getdepartment?superid=${superId}`, {
            headers: { Authorization: `Bearer FFC10000-022A-4030-0000-DA26AE3BA419-3` },
        })
            .then(r => r.json())
            .then(data => {
                if (data?.status) {
                    setDepartments(data.ResultData?.filter(d => d.IsActive) || []);
                }
            })
            .catch(console.error);

        fetch(`${Payroll_API_BASE_URL}payroll/payroll/getPayPeriods?SuperId=${superId}`, {
            headers: { Authorization: `Bearer FFC10000-022A-4030-0000-DA26AE3BA419-3` },
        })
            .then(r => r.json())
            .then(data => {
                if (data?.status) {
                    setPayPeriods(data.ResultData || []);
                }
            })
            .catch(console.error);
    }, [token, superId]);

    useEffect(() => {
        if (!token || !superId) return;

        const isAdvanced = showAdvancedSearch;
        const branchId = isAdvanced && selectedBranch?.value ? selectedBranch.value : 0;
        const deptId = isAdvanced && selectedDepartment?.value ? selectedDepartment.value : 0;

        if (isAdvanced && (!branchId || !deptId)) {
            setEmployees([]);
            setSelectedEmployee(null);
            return;
        }

        const url = `${Payroll_API_BASE_URL}payroll/payroll/getemployees?superid=${superId}&BranchId=${branchId}&DeptId=${deptId}`;

        fetch(url, {
            headers: { Authorization: `Bearer FFC10000-022A-4030-0000-DA26AE3BA419-3` },
        })
            .then(r => r.json())
            .then(data => {
                if (data?.status) {
                    const emps = data.ResultData || [];
                    setEmployees(emps);
                    // Clear employee selection if not in current list
                    if (selectedEmployee?.value && !emps.some(e => e.RegId === selectedEmployee.value)) {
                        setSelectedEmployee(null);
                    }
                } else {
                    setEmployees([]);
                }
            })
            .catch(err => {
                console.error(err);
                setEmployees([]);
            });
    }, [token, superId, showAdvancedSearch, selectedBranch, selectedDepartment]);

    const branchOptions = [
        { value: "", label: "Select Branches" },
        ...branches.map(b => ({ value: b.BranchId || b.branchid, label: b.Name })),
    ];

    const deptOptions = [
        { value: "", label: "Select Departments" },
        ...departments.map(d => ({ value: d.DepartmentId, label: d.Name })),
    ];

    const payPeriodOptions = [
        { value: "", label: "Select PayPeriods" },
        ...payPeriods.map(p => ({
            value: p.Id,
            label: p.Name,
        })),
    ];

    const employeeOptions = [
        { value: "", label: "Select Employees" },
        ...employees.map(emp => ({
            value: emp.RegId,
            label: emp.UserWithBadge || `${emp.UserName || emp.Name || "Employee"} (${emp.BadgeId || "N/A"})`,
        })),
    ];
    
useEffect(() => {
    if (payPeriods.length > 0 && selectedPayPeriod === null) {
        const latest = payPeriods[0]; // March-2024

        setSelectedPayPeriod({
            value: latest.Id,
            label: latest.Name,
        });
    }
}, [payPeriods, selectedPayPeriod]);

    useEffect(() => {
        setSelectedPayPeriod(null);
        setSelectedEmployee(null);
        setSelectedDepartment(null);
        setSelectedBranch(null);
        setShowAdvancedSearch(false);
        setReportData([]);
        setColumns([]);
    }, [reportiid]);

    const fetchReport = async () => {
        if (!token || !superId || !reportiid) return;
        setLoading(true);

        try {
            const params = new URLSearchParams({
                superid: superId,
                reportiid,
            });

            if (selectedPayPeriod?.value) params.append("PayperiodId", selectedPayPeriod.value);
            if (selectedEmployee?.value) params.append("RegId", selectedEmployee.value);
            if (selectedDepartment?.value) params.append("DeptId", selectedDepartment.value);
            if (selectedBranch?.value) params.append("BranchId", selectedBranch.value);

            const url = `${Payroll_API_BASE_URL}payroll/Reports/getpayrollReports?${params}`;
            const res = await fetch(url, { headers: { Authorization: `Bearer FFC10000-022A-4030-0000-DA26AE3BA419-3` } });
            const result = await res.json();

            if (result?.status && result.header?.length > 0) {
                const headers = result.header;
                const keys = headers.map(h => h.replace(/\s+/g, "_").toLowerCase());

                const dynamicCols = headers.map((title, i) => ({
                    title,
                    dataIndex: keys[i],
                    key: keys[i],
                    render: val => (typeof val === "string" && val.includes("T") && val.includes("-"))
                        ? val.split("T")[0]
                        : val ?? "-",
                }));

                setColumns([
                    { title: "S.No", render: (_, __, idx) => idx + 1, width: 60 },
                    ...dynamicCols,
                ]);

                setReportData(
                    result.ResultData.map(row => {
                        const newRow = {};
                        headers.forEach((h, i) => { newRow[keys[i]] = row[h]; });
                        return newRow;
                    })
                );
            } else {
                setColumns([]);
                setReportData([]);
            }
        } catch (err) {
            console.error(err);
            setReportData([]);
            setColumns([]);
        } finally {
            setLoading(false);
        }
    };

    // Your export functions (unchanged)
const exportToExcel = () => {
    console.log("Excel clicked");

    if (!reportData || reportData.length === 0) {
        // alert("No data available");
        return;
    }
    setExcelLoading(true);

    try {
        const ws = XLSX.utils.json_to_sheet(reportData);
        const wb = XLSX.utils.book_new();

        XLSX.utils.book_append_sheet(wb, ws, "Report");
        XLSX.writeFile(wb, `Report_${reportiid}.xlsx`);
    } catch (err) {
        console.error("Excel Export Error:", err);
    }
    setExcelLoading(false);
};

   const exportToPDF = () => {
    console.log("PDF clicked");

    if (!reportData || reportData.length === 0) {
        // alert("No data available");
        return;
    }
    setPdfLoading(true);

    try {
        const doc = new jsPDF({ orientation: "landscape" });

        doc.text(`Payroll Report ${reportiid}`, 14, 15);

        autoTable(doc, {
            head: [columns.map(c => c.title)],
            body: reportData.map(row =>
                columns.map(c => (c.dataIndex ? row[c.dataIndex] : ""))
            ),
            startY: 25,
            styles: { fontSize: 8 }
        });

        doc.save(`Report_${reportiid}.pdf`);
    } catch (err) {
        console.error("PDF Export Error:", err);
    }
    setPdfLoading(false);
};

    const REPORT_NAME_MAP = {
        "501": "Salary Report",
        "502": "PF Report",
        "503": "ESI Report",
        "506": "Salary Bank Statement",
    };
    const reportName = REPORT_NAME_MAP[reportiid] || "Payroll Report";

    return (
        <>
            {(pdfLoading || excelLoading || loading) && (
                <div className="overlay-spinner">
                    <Spin size="large" tip={loading ? "Loading report..." : "Exporting..."} />
                </div>
            )}

            <div className="page-wrapper">
                <div className="content">
                    <div className="page-header d-flex justify-content-between align-items-center">
                        <div>
                            <h4>{reportName} </h4>
                            <h6>Payroll Report Viewer</h6>
                        </div>

                        <ul className="table-top-head">
                            <li>
                                <OverlayTrigger placement="top" overlay={<Tooltip>PDF</Tooltip>}>
                                    <a onClick={exportToPDF}>
                                        <ImageWithBasePath src="assets/img/icons/pdf.svg" alt="pdf" />
                                    </a>
                                </OverlayTrigger>
                            </li>
                            <li>
                                <OverlayTrigger placement="top" overlay={<Tooltip>Excel</Tooltip>}>
                                    <a onClick={exportToExcel}>
                                        <ImageWithBasePath src="assets/img/icons/excel.svg" alt="excel" />
                                    </a>
                                </OverlayTrigger>
                            </li>
                            <li>
                                <OverlayTrigger placement="top" overlay={<Tooltip>Refresh</Tooltip>}>
                                    <a onClick={() => window.location.reload()}>
                                        <RotateCcw />
                                    </a>
                                </OverlayTrigger>
                            </li>
                        </ul>
                    </div>

                    <div className="card mb-3">
                        <div className="card-body">
                            <div className="row g-3 align-items-end">
                                <div className="col-lg-2 col-sm-6 col-12">
                                    <label className="form-label">Pay Period</label>
                                    <Select
                                        classNamePrefix="react-select"
                                        options={payPeriodOptions}
                                        value={selectedPayPeriod}
                                        onChange={setSelectedPayPeriod}
                                        placeholder="Select PayPeriod"
                                        isClearable
                                        isSearchable
                                    />
                                </div>
                                {showAdvancedSearch && (
                                    <>
                                        <div className="col-lg-2 col-sm-6 col-12">
                                            <label className="form-label">Branch</label>
                                            <Select
                                                classNamePrefix="react-select"
                                                options={branchOptions}
                                                value={selectedBranch}
                                                onChange={setSelectedBranch}
                                                placeholder="Select Branches"
                                                isClearable
                                                isSearchable
                                            />
                                        </div>

                                        <div className="col-lg-2 col-sm-6 col-12">
                                            <label className="form-label">Department</label>
                                            <Select
                                                classNamePrefix="react-select"
                                                options={deptOptions}
                                                value={selectedDepartment}
                                                onChange={setSelectedDepartment}
                                                placeholder="Select Departments"
                                                isClearable
                                                isSearchable
                                            />
                                        </div>
                                    </>
                                )}

                                <div className="col-lg-2 col-sm-6 col-12">
                                    <label className="form-label">Employee</label>
                                    <Select
                                        classNamePrefix="react-select"
                                        options={employeeOptions}
                                        value={selectedEmployee}
                                        onChange={setSelectedEmployee}
                                        placeholder="Select Employees"
                                        isClearable
                                        isSearchable
                                    />
                                </div>
                                <div className="col-auto d-flex align-items-center gap-2">

                                    <button
                                        className="btn btn-outline-primary d-flex align-items-center justify-content-center"
                                        style={{ width: 48, height: 38 }}
                                        onClick={() => {
                                            const newVal = !showAdvancedSearch;
                                            setShowAdvancedSearch(newVal);

                                            if (!newVal) {
                                                setSelectedBranch(null);
                                                setSelectedDepartment(null);
                                            }

                                            setSelectedEmployee(null);
                                        }}
                                        title={showAdvancedSearch ? "Hide Advanced Filters" : "Show Advanced Filters"}
                                    >
                                        {showAdvancedSearch ? <Search size={20} /> : <Filter size={20} />}
                                    </button>

                                    <button
                                        className="btn btn-primary d-flex align-items-center justify-content-center"
                                        style={{ height: 38, minWidth: 45 }}
                                        onClick={fetchReport}
                                    >
                                        <i className="fa fa-chart-bar me-1" />
                                    </button>

                                </div>

                            </div>
                        </div>
                    </div>

                    <div className="card">
                        <div className="card-body p-0">
                            {loading ? (
                                <div className="text-center py-5"><Spin size="large" /></div>
                            ) : columns.length === 0 ? (
                                <div className="text-center py-5 text-muted">
                                    Select filters and click Generate to view report
                                </div>
                            ) : (
                                <div className="table-responsive">
                                    <Table
                                        columns={columns}
                                        dataSource={reportData}
                                        rowKey={(_, i) => i}
                                        pagination={{ pageSize: 15, showSizeChanger: true }}
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                </div>

                <CommonFooter />
            </div>
        </>
    );
};

export default GroupPayrollReports;